import { useMemo } from 'react';

export const useGreetings = () =>
  useMemo(() => {
    const greetings = [
      'Who needs cold emails when you have warm intros?',
      'Unlock 10x growth by tapping into your extended network.',
      'Growth happens through introductions. Let’s unlock yours today.',
      'Ditch the coffee ☕ warm up with warm intros.',
      'The intro you need is closer than you think. Let’s find it!',
      'The right intro can change everything—let’s find the right one for you!',
      'Your next deal, hire, or investor is just an introduction away.',
      'Forget cold outreach. Let’s turn your network into a growth engine!',
      'Forget spreadsheets. Let’s streamline your networking!',
      'Your network is more than a contact list—it’s a goldmine of opportunities. Let’s unlock it!',
      '82% of B2B sales leaders say referrals are the best leads. Let’s get you more of them!',
      '40% of all hires come from referrals—your next great hire could be a warm intro away.',
      'Referrals convert better, close faster, and last longer. Let’s find yours!',
      'Faster intros, better connections, real results. Let’s go!',
      'No magic wands needed, just Getro and your network is enough ✨',
      'Your network is basically a cheat code for success. Let’s press start! 🎮',
    ];
    const randomIndex = Math.floor(Math.random() * greetings.length);
    return greetings[randomIndex];
  }, []);
